import ApiService from '@/services/core/api.service'

const VehicleService = {
  async get (query) {
    return ApiService.get(`senior-mechanic/maintenance-vehicles?${query}`)
  },

  async post (payload) {
    return ApiService.post('senior-mechanic/maintenance-vehicles', payload)
  },

  async put (payload) {
    return ApiService.put(`senior-mechanic/maintenance-vehicles/${payload.id}`, payload)
  }
}

export default VehicleService
